<template>
    <div>
        <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />
        <div class="row px-md-4">
            <div class="row px-md-4">
                <div class="col-lg-3 d-flex" v-for="(item, index) in program">
                    <div class="card flex-fill border border-success riseup-tindahan">
                        <div v-if="item.logo_path">
                            <img class="card-img-top mt-3 px-3" :src="item.logo_path" alt="Image" @error="onImageError(index)" v-if="!logoError[index]">
                            <div class="fs-44 text-center pt-5" v-if="logoError[index]"><b>{{item.program_name}}</b></div>
                        </div>
                        <div class="fs-44 text-center pt-5" v-else><b>{{item.program_name}}</b></div>

                        <div class="card-body">
                            <p class="text-justify">{{item.menu_desc}}</p>
                        </div>
                        <div class="card-footer bg-none mx-auto">
                            <button type="button" class="btn btn-success btn-lg px-5" @click="applyLoan(item)">APPLY</button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 d-flex" v-if="program.length">
                    <div class="card flex-fill border border-success riseup-tindahan">
                        <div>
                            <img class="card-img-top mt-3 px-3" src="images/women-fund.jpg" alt="Image">
                        </div>
                        <div class="card-body">
                            <p class="text-justify">Accessible funding solutions designed to contribute to economic inclusion by empowering and sustaining the growth of all women-owned and women-led micro, small, and medium enterprises (WMSMEs)</p>
                        </div>
                        <div class="card-footer bg-none mx-auto">
                            <button type="button" class="btn btn-success btn-lg px-5" @click="qualifyWEF">APPLY</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modalFLP" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">Franchising Loan Program</h5>
                    </div>
                    <div class="modal-body">
                        <transition name="fade">
                            <div class="alert alert-danger2 alert-dismissible mb-2" v-if="msg">
                                <button type="button" class="close mt-n1" data-dismiss="alert" @click="msg=null">&times;</button>
                                <p class="text-justify p-0 m-0">{{msg}}</p>
                            </div>
                        </transition>
                        <div class="form-group">
                            <label>Please enter your <b>Reference No.</b></label>
                            <input class="form-control text-uppercase" v-model="ref_no">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" @click="closeFLP">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="submitFLP()">Submit</button>
                    </div>
                </div>
            </div>
        </div>

        <ModalWEF />
    </div>
</template>

<script>
    import ModalWEF from './ModalWEF.vue' // adjust path as needed
    export default {
        components: {
            ModalWEF
        },
        data() {
            return {
                logoError: {},
                loader: false,
                menu: [],
                program: [],
                ref_no: '',

                flp: {},
                msg: '',
            }
        },

        created() {
            this.getMenu();
        },
        methods: {
            qualifyWEF() {
                this.loader++;
                axios.get('/api/sblaf-qualify-wef')
                    .then(res => {
                        let data = res.data;
                        if (data.qualified) {
                            $('#modalWEF').modal('show');
                        } else {
                            Swal.fire({
                                icon: "info",
                                title: "NOTICE",
                                text: `This loan program is exclusively for women entrepreneurs.`,
                                allowOutsideClick: false,
                            }).then((response) => {});
                        }
                        this.loader--;
                    }).catch(err => {
                        this.loader--;
                    })

            },
            onImageError(index) {
                this.$set(this.logoError, index, true);
            },
            submitFLP() {
                this.loader++;
                axios.post('/api/franchising-qualification', {
                        ...this.flp,
                        ref_no: this.ref_no,
                        program: 'franchising'
                    })
                    .then(res => {
                        this.loader--;
                        const {
                            eligible,
                            message
                        } = res.data;

                        if (eligible) {
                            this.closeFLP();
                            this.$router.push(`/apply-loan/franchising`);
                        } else {
                            this.msg = message;
                        }
                    }).catch(err => {
                        this.loader--;
                    })
            },
            closeFLP() {
                $('#modalFLP').modal('hide');
                this.msg = null;
                this.ref_no = null;
            },
            applyLoan(item) {
                if (item.loan_bus_code == 'FIB18') {
                    this.applyStartup(item, 'startup');
                } else if (item.loan_bus_code == 'FIB19') {
                    this.flp = item;
                    $('#modalFLP').modal('show');
                } else if (item.loan_bus_code == 'FIB20') {
                    this.applyStartup(item, 'po-financing');
                }
            },
            swalIneligible(message) {
                Swal.fire({
                    icon: 'warning',
                    html: `<p class="mx-n2 text-justify">${message}</p>`,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowOutsideClick: false,

                })
            },

            applyStartup(item = {}, program) {
                this.loader++;
                axios.post('/api/startup-qualification', {
                        ...item,
                        program: program
                    })
                    .then(res => {
                        this.loader--;
                        let data = res.data;
                        let ineligible = data.ineligible ?? false;
                        if (ineligible) {
                            this.swalIneligible(data.message);
                        } else {
                            this.$router.push(`/apply-loan/${program}`);
                        }
                    }).catch(err => {
                        this.loader--;
                    })
            },

            getMenu() {
                this.loader++;
                axios.get('/api/sblaf-menu-new')
                    .then(res => {
                        let data = res.data;
                        this.program = data.program;
                        this.loader--;
                    }).catch(err => {
                        this.loader--;
                    })
            },
        },
        computed: {
            processingAPI() {
                return this.loader > 0;
            },
        },
        mounted() {}
    }
</script>
<style scoped>
    .btn-fit {
        border-radius: 0 !important;
        width: 100%;
    }

    .alert-danger2 {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
    }

    .riseup-mp {
        border-color: #fe9900 !important;
        border-width: 7px !important
    }

    .riseup-turismo {
        border-color: #263d81 !important;
        border-width: 7px !important
    }

    .riseup-tindahan {
        /* border-color: #78a236 !important; */
        border-width: 7px !important
    }

    .bg-none {
        background-color: transparent !important;
    }

    .bl {
        color: black;
    }

    .bg-gray {
        background-color: #f3f3f3 !important;
    }

    .bg-gray2 {
        background-color: #E5E5E5 !important;
    }
</style>